module.exports = __webpack_public_path__ + "static/media/aicpa-logo.f97b4fbd.svg";